import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { getFormattedProfileKey } from 'utils/users'
import {
  Label,
  ButtonGroup
} from 'react-bootstrap'
import { Modal } from 'components/Modal'
import User from 'components/User'
import KanBoIcon from 'components/KanBoIcon'
import Button from 'components/Button'
import Loader from 'components/Loader'
import Scrollbars from 'components/Scrollbars'
import {
  ListItem
} from 'components/List'
import Editable from 'components/Editable'
import { LeftSidebarView } from 'components/Sidebar'
import HiddenFileInput from 'components/HiddenFileInput'
import ReactCrop from 'react-image-crop'
import classes from './UserProfile.module.scss'
import { Promise } from 'core-js'
import styled from 'styled-components'

const StyledReactCrop = styled(ReactCrop)`
  flex: 0 0 auto;
  align-self: flex-start;
  margin-bottom: 10px;
`

const defaultCrop = {
  unit: '%',
  x: 0,
  y: 0,
  width: 100,
  aspect: 1,
}

export class UserProfile extends React.Component {
  static propTypes = {
    profileKey: PropTypes.string,

    id: PropTypes.number,
    name: PropTypes.string,
    licenseType: PropTypes.number,
    profile: PropTypes.object,
    isActive: PropTypes.bool,
    currentUser: PropTypes.object.isRequired,
    isAvatarSet: PropTypes.bool.isRequired,

    fetchProfile: PropTypes.func.isRequired,
    requestChangeCurrentUserProfile: PropTypes.func.isRequired,
    requestChangeCurrentUserAvatar: PropTypes.func.isRequired,
    showProfile: PropTypes.func.isRequired
  }

  state = {
    image: null,
    crop: defaultCrop
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.profileKey !== this.props.profileKey) {
      this.setState({
        image: null,
        crop: defaultCrop
      })

      if (nextProps.profileKey && !nextProps.profile.isLoading) {
        nextProps.fetchProfile({
          profileKey: nextProps.profileKey
        })
      }
    }
  }

  getCroppedImg = (imageData, crop) => {
    return new Promise((resolve, reject) => {
      var image = new Image()

      image.onload = () => {
        const cropWidth = image.naturalWidth * (crop.width / 100)
        const cropHeight = image.naturalHeight * (crop.height / 100)
        const startX = image.naturalWidth * (crop.x / 100)
        const startY = image.naturalHeight * (crop.y / 100)

        const canvas = document.createElement('canvas')
        canvas.width = 500
        canvas.height = 500
        const ctx = canvas.getContext('2d')

        ctx.drawImage(
          image,
          startX,
          startY,
          cropWidth,
          cropHeight,
          0,
          0,
          500,
          500
        )

        resolve(canvas.toDataURL().replace(/data:[^;]*;base64,/, ''))

        image = null
      }

      image.onerror = () => {
        reject()

        image = null
      }

      image.src = imageData
    })
  }

  getDataUrlFromFile = (file) => {
    return new Promise((resolve, reject) => {
      if (!file.type.match('image.*')) {
        reject()
      }
      var reader = new FileReader()
      reader.onload = function (event) {
        resolve(event.target.result)
      }
      reader.readAsDataURL(file)
    })
  }

  handleClose = () => {
    this.props.showProfile({
      profileKey: null
    })
  }

  handleChangeAvatarClose = () => {
    this.setState({
      image: null,
      crop: defaultCrop
    })
  }

  handleSaveAvatarClick = async () => {
    const {
      requestChangeCurrentUserAvatar
    } = this.props
    const {
      image,
      crop
    } = this.state

    const avatar = await this.getCroppedImg(image, crop)

    requestChangeCurrentUserAvatar({
      avatar
    })

    this.setState({
      image: null,
      crop: defaultCrop
    })
  }

  handleCropChange = (crop, percentCrop) => {
    this.setState({
      crop: percentCrop
    })
  }

  handleRemoveAvatarClick = () => {
    const {
      requestChangeCurrentUserAvatar
    } = this.props

    requestChangeCurrentUserAvatar({
      avatar: null
    })
  }

  renderName = () => {
    const {
      profileKey,
      profile,
      licenseType,
      isActive
    } = this.props

    if (profile.isLoaded && (profile.fields.name || profile.fields.surname)) {
      return (
        <div className={classes.userName}>
          <div className={classes.name}>
            {profile.fields.name}{' '}{profile.fields.surname}
            {licenseType === 1 &&
              <span>
                {' '}
                <Label bsStyle='info'><FormattedMessage id='LICENSE_READER' /></Label>
              </span>
            }
            {isActive === false &&
              <span>
                {' '}
                <Label><FormattedMessage id='USER_DEACTIVATED' /></Label>
              </span>
            }
          </div>
          <small>
            {getFormattedProfileKey(profileKey)}
          </small>
        </div>
      )
    } else {
      return (
        <div className={classes.userName}>
          <div className={classes.name}>
            {getFormattedProfileKey(profileKey)}
            {licenseType === 1 &&
              <span>
                {' '}
                <Label bsStyle='info'><FormattedMessage id='LICENSE_READER' /></Label>
              </span>
            }
            {isActive === false &&
              <span>
                {' '}
                <Label><FormattedMessage id='USER_DEACTIVATED' /></Label>
              </span>
            }
          </div>
        </div>
      )
    }
  }

  renderField = (name) => {
    const {
      profile
    } = this.props

    if (profile.fields[name]) {
      return profile.fields[name]
    } else {
      return (
        <span className={classes.emptyField}>
          <FormattedMessage id='NOTHING_TO_SHOW' />
        </span>
      )
    }
  }

  renderEditableField = (name, editableOptions = {}) => {
    const {
      profileKey,
      profile,
      currentUser,
      requestChangeCurrentUserProfile
    } = this.props

    const isCurrentUserProfile = profileKey === currentUser.profileKey

    if (profile.canEditKanBoProfile && isCurrentUserProfile) {
      const onSubmit = (editableFields) => {
        requestChangeCurrentUserProfile({
          [name]: editableFields.name
        })
      }
      return (
        <Editable
          {...editableOptions}
          initialValues={{ name: profile.fields[name] || '' }}
          onSubmit={onSubmit}
        >
          {this.renderField(name)}
        </Editable>
      )
    } else {
      return this.renderField(name)
    }
  }

  handleFileInputChange = (event) => {
    const files = event.target.files
    if (files[0]) {
      this.getDataUrlFromFile(files[0]).then((dataUrl) => {
        this.setState({
          image: dataUrl
        })
      })
    }
  }

  render () {
    const {
      profileKey,
      name,
      profile,
      isActive,
      currentUser,
      isAvatarSet
    } = this.props
    const {
      image,
      crop
    } = this.state

    const isCurrentUserProfile = profileKey === currentUser.profileKey

    const contactFields = [{
      name: 'email',
      icon: 'kanbo-16-envelope'
    }, {
      name: 'phone',
      icon: 'kanbo-16-phone'
    }]

    const nameFields = [{
      name: 'name',
      messageId: 'NAME_USER'
    }, {
      name: 'surname',
      messageId: 'SURNAME'
    }]

    const aboutFields = [{
      name: 'aboutMe',
      messageId: 'USER_ABOUT_ME'
    }, {
      name: 'askMeAbout',
      messageId: 'USER_ASK_ABOUT_ME'
    }]

    return (
      <React.Fragment>
        {!!profileKey && (
          <Modal onClose={this.handleClose}>
            <LeftSidebarView
              contentStyle={{ padding: '0 10px 10px 10px' }}
              className={isActive === false ? classes.deactivated : null}
              title={this.renderName()}
            >
              {!profile.isLoaded &&
                <Loader center />
              }
              {profile.isLoaded &&
                <div className={classes.userContent}>
                  <div className={classes.left}>
                    <div className={classes.avatarWrapper}>
                      {(profile.canEditKanBoProfile && isCurrentUserProfile) &&
                        <div className={classes.avatarOverlay}>
                          <KanBoIcon name='kanbo-16-camera' style={{ fontSize: 16, marginRight: '0.5em' }} />
                          <FormattedMessage id='USER_CHANGE_AVATAR' />
                          <HiddenFileInput
                            accept='image/*'
                            onChange={this.handleFileInputChange}
                          />
                        </div>
                      }
                      {(profile.canEditKanBoProfile && isCurrentUserProfile && isAvatarSet) &&
                        <div
                          className={classes.avatarRemove}
                          onClick={this.handleRemoveAvatarClick}
                        >
                          <KanBoIcon name='kanbo-16-remove' style={{ fontSize: 16, marginRight: '0.5em' }} />
                          <FormattedMessage id='REMOVE' />
                        </div>
                      }

                      <User
                        avatar
                        size={260}
                        profileKey={profileKey}
                        name={name}
                        className={classes.avatar}
                      />
                    </div>
                    <div>
                      {contactFields.map(contact => {
                        return (
                          <ListItem
                            key={contact.name}
                            icon={
                              <KanBoIcon fixedWidth name={contact.icon} />
                            }
                          >
                            {this.renderEditableField(contact.name)}
                          </ListItem>
                        )
                      })}
                    </div>
                  </div>
                  <div className={classes.right}>
                    <Scrollbars
                      className={classes.rightContent}
                    >
                      {(profile.isLoaded && profile.canEditKanBoProfile && isCurrentUserProfile) &&
                        nameFields.map(nameField => {
                          return (
                            <div
                              key={nameField.name}
                              className={classes.section}
                            >
                              <div className={classes.sectionTitle}>
                                <FormattedMessage id={nameField.messageId} />
                              </div>
                              <div className={classes.sectionBody}>
                                {this.renderEditableField(nameField.name)}
                              </div>
                            </div>
                          )
                        })}
                      {profile.isLoaded && aboutFields.map(about => {
                        return (
                          <div
                            key={about.name}
                            className={classes.section}
                          >
                            <div className={classes.sectionTitle}>
                              <FormattedMessage id={about.messageId} />
                            </div>
                            <div className={classes.sectionBody}>
                              {this.renderEditableField(about.name, { textarea: true })}
                            </div>
                          </div>
                        )
                      })}
                    </Scrollbars>
                  </div>
                </div>
              }
            </LeftSidebarView>
          </Modal>
        )}
        {!!image && (
          <Modal onClose={this.handleChangeAvatarClose}>
            <LeftSidebarView
              contentStyle={{ padding: '0 10px 10px 10px' }}
              title={this.renderName()}
              onCloseClick={this.handleChangeAvatarClose}
            >
              <StyledReactCrop
                src={image}
                crop={crop}
                onChange={this.handleCropChange}
                keepSelection
              />
              <ButtonGroup>
                <Button bsStyle='primary' onClick={this.handleSaveAvatarClick}>
                  <FormattedMessage id='SAVE' />
                </Button>
                <Button onClick={this.handleChangeAvatarClose}>
                  <FormattedMessage id='CANCEL' />
                </Button>
              </ButtonGroup>
            </LeftSidebarView>
          </Modal>
        )}
      </React.Fragment>
    )
  }
}

export default UserProfile

